import React, { useState } from "react";
import "./QuantumResearch.css";
import QuantumEchoesDemo from "./QuantumEchoesDemo";
import MultiQubitEchoDemo from "./MultiQubitEchoDemo"; // <-- new experiment
import QuantumNoiseVisualizer from "./QuantumNoiseVisualizer";
import QuantumSuperpositionField from "./QuantumSuperpositionField";
import QuantumAweExperience from "./QuantumAweExperience";
import QubitDecayLab from "./QubitDecayLab";
import DualQubitDecayLab from "./DualQubitDecayLab"; // <-- the integrated 2D + 3D lab

import image1 from "../../assets/1.png";
import image2 from "../../assets/2.png";
import image3 from "../../assets/3.png";
import image4 from "../../assets/4.png";
import { numberValueTypes } from "framer-motion";

export default function QuantumResearch() {
  const [activeExp, setActiveExp] = useState(null);

  const experiments = [
    {
      id: "echoes",
      name: "Quantum Echoes Experiment",
      desc: "Simulate Google’s 2025 quantum coherence echo experiment.",
      img: image1,
      component: <QuantumEchoesDemo />,
      status: "active",
    },
    {
      id: "multiEcho",
      name: "Multi-Qubit Echo Coupling",
      desc: "Visualize a 40-qubit echo array and observe sync effects.",
      img: image2,
      component: <MultiQubitEchoDemo />,
      status: "active",
    },
    {
      id: "noise",
      name: "Quantum Noise Visualizer Simulation",
      desc: "Visualize noise propagation across qubits.",
      img: image3,
      component: <QuantumNoiseVisualizer />,
      status: "active",
    },
    {
      id: "superposition",
      name: "Quantum Superposition Field",
      desc: "Explore dynamic phase interference patterns across entangled qubits.",
      img: image4,
      component: <QuantumSuperpositionField />,
      status: "active",
    },
    // {
    //   id: "decay",
    //   name: "Qubit Decay Simulation",
    //   desc: "Observe decoherence and energy loss in a 40-qubit system.",
    //   img: image4, // or a new decay-themed asset
    //   component: <QubitDecayLab />,
    //   status: "active",
    // },
    
    
  ];

  const activeExperiment = experiments.find((exp) => exp.id === activeExp);

  if (activeExperiment && activeExperiment.status === "active") {
    return (
      <div className="qr-root">
        <button className="qr-back-btn" onClick={() => setActiveExp(null)}>
          ← Back to Research Hub
        </button>
        {activeExperiment.component}
      </div>
    );
  }

  return (
    <div className="qr-root">
      <h2 className="qr-title">🧬 Quantum Research</h2>
      <p className="qr-subtitle">
        Experimental quantum physics simulations — inspired by real lab breakthroughs.
      </p>

      <div className="qr-grid">
        {experiments.map((exp) => (
          <div
            key={exp.id}
            className={`qr-card ${exp.status}`}
            onClick={() =>
              exp.status === "active" ? setActiveExp(exp.id) : null
            }
          >
            <div
              className="qr-card-img"
              style={{ backgroundImage: `url(${exp.img})` }}
            ></div>

            <div className="qr-card-body">
              <h3>{exp.name}</h3>
              <p>{exp.desc}</p>
              {exp.status === "active" ? (
                <button className="qr-btn">Open Experiment</button>
              ) : (
                <button className="qr-btn disabled">Coming Soon</button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
